import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import TeamDepartmentModal from './TeamDepartmentModal';

const TeamDepartment = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [departments, setDepartments] = useState([
        // Sample data (replace with actual data)
        { department: 'Human Resources', status: 'Active' },
        { department: 'Engineering', status: 'Deactive' },
        { department: 'Marketing', status: 'Active' },
    ]);
    const [filteredDepartments, setFilteredDepartments] = useState(departments);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = departments.filter((dept) =>
            Object.values(dept).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredDepartments(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, departments]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredDepartments.length / itemsPerPage);
    const currentData = filteredDepartments.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setDepartments((prevDepartments) =>
            prevDepartments.map((dept, i) =>
                i === index
                    ? { ...dept, status: dept.status === 'Active' ? 'Deactive' : 'Active' }
                    : dept
            )
        );
    };

    const handleDelete = (index) => {
        const updatedData = currentData.filter((_, i) => i !== index);
        setDepartments(updatedData); 
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Team department</h1>

                    {/* Add Fees Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add department
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Team Department Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Department</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((dept, index) => (
                                    <tr key={index}>
                                        <td>{dept.department}</td>
                                        <td>{dept.status}</td>
                                        <td>
                                            <button onClick={() => setIsModalOpen(true)}>
                                                <i className="fa fa-pen"></i> {/* Edit Button */}
                                            </button>
                                            <button onClick={() => toggleStatus(index)}>
                                                <i
                                                    className={`fa ${dept.status === 'Active'
                                                        ? 'fa-toggle-on'
                                                        : 'fa-toggle-off'
                                                        }`}
                                                ></i> {/* Toggle Status */}
                                            </button>
                                            <button onClick={() => handleDelete(index)}>
                                                <i className="fa-solid fa-trash delete-oms"></i> {/* Delete Button */}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: 'center' }}>
                                        No departments found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <TeamDepartmentModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default TeamDepartment;
